import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'ng-casto-marketing-consent-selector',
  templateUrl: './marketing-consent-selector.component.html',
})
export class MarketingConsentSelectorComponent {
  @Input() marketingConsentFormGroup: FormGroup;
}
